import { format, parseISO } from 'date-fns';

export const formatDate = (date: string) => {
    const parsedDate = parseISO(date);
    return format(parsedDate, 'MMMM d, yyyy');
};

export const getCurrentYear = () => {
    return new Date().getFullYear();
}